import { apiClient } from '../lib/api';
import type { TenantMember, SearchMembersParams } from '../types/chat';

interface PaginatedEnvelope<T> {
  status: 'success';
  data: T[];
  meta?: { total: number; page: number; per_page: number; pages: number };
}

function buildQuery(params: object): string {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params as Record<string, unknown>)) {
    if (v === undefined || v === null || v === '') continue;
    if (typeof v === 'boolean') search.set(k, v ? 'true' : 'false');
    else search.set(k, String(v));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export async function searchTenantMembers(
  params: SearchMembersParams = {}
): Promise<{
  members: TenantMember[];
  meta?: { total: number; page: number; per_page: number; pages: number };
}> {
  const res = await apiClient.get<PaginatedEnvelope<TenantMember>>(
    `/tenant/members${buildQuery(params)}`
  );
  return { members: res.data, meta: res.meta };
}
